import * as React from 'react';
import styled from 'styled-components';

interface ILogo {
  name: any;
  style?: any;
}

export const SectionLogo: React.FC<ILogo> = ({ name, style }) => {
  return (
    <StyledOfficeLogo style={style}>
      <img
        src="https://cdn.reeltime.no/pm_assets/img/kontor/office_logo.png"
        width="100%"
      />

      <svg
        className="office-name"
        viewBox="0 0 1001 300"
        height="30px"
        width="100%"
        xmlns="http://www.w3.org/2000/svg"
        textAnchor="middle"
      >
        <linearGradient id="grad1" x1="10%" y1="30%" x2="80%" y2="80%">
          <stop
            offset="0%"
            stopColor="rgb(193, 126, 84)"
            stopOpacity="1"
          ></stop>
          <stop
            offset="50%"
            stopColor="rgb(241,192,135)"
            stopOpacity="1"
          ></stop>
          <stop
            offset="100%"
            stopColor="rgb(185,113,73)"
            stopOpacity="1"
          ></stop>
        </linearGradient>
        <text x="50%" y="50%" fill="url(#grad1)" dominantBaseline="middle">
          {name}
        </text>
      </svg>
    </StyledOfficeLogo>
  );
};

const StyledOfficeLogo = styled.div`
  width: 100%;
  margin-top: 1em;

  .office-name {
    position: relative;
    top: -10px;

    text {
      text-transform: uppercase;
      font-size: 150px;
    }
  }

  @media all and (max-width: 800px) {
    max-width: 200px;

    .office-name {
      top: -5px;
      height: 25px;
      left: 0em;
    }
  }

  @media all and (max-width: 450px) {
    img {
      width: 187px;
      height: 110px;
      margin-top: 0em;
      margin-left: -10px;
    }
  }
`;
